export default __webpack_public_path__ + "static/media/torso-low-right-side.ced71335.png";